/*
Ashraf 01/22/2023 2698088984 added dynamic field validations for batch account details form

*/

import * as yup from 'yup';

export function createYupSchema(schema, config) {
  const {
    fieldName,
    fieldLabel,
    isMandatory,
    fieldType,
  } = config;
  if (fieldType === 'ssn') {
    const validator =
      isMandatory === 'Y' ?
        yup
          .string()
          .transform((value) =>
            value === '' || value === null || value === undefined ? null : value,
          )
          .required(`${fieldLabel} is required`)
          .test('ssn', `Invalid  ${fieldLabel}`, (value) => {
            if (
              (value && /^([0-9])(\d{2})-(\d{2})-(\d{4})(?<!(\1{3}-\1{2}-\1{4}))$/.test(value)) ||
                !value
            ) {
              return true;
            }
          })
          .nullable() :
        yup
          .string()
          .transform((value) =>
            value === '' || value === null || value === undefined ? null : value,
          )
          .test('ssn', `Invalid  ${fieldLabel}`, (value) => {
            if (
              (value && /^([0-9])(\d{2})-(\d{2})-(\d{4})(?<!(\1{3}-\1{2}-\1{4}))$/.test(value)) ||
                !value
            ) {
              return true;
            }
          })
          .nullable();
    schema[fieldName] = validator;
  } else if (fieldType === 'phone') {
    const validator =
      isMandatory === 'Y' ?
        yup
          .string()
          .transform((value) =>
            value === '' || value === null || value === undefined ? null : value,
          )
          .required(`${fieldLabel} is required`)
          .test('Phone', `Invalid  ${fieldLabel}`, (value) => {
            const phoneValue = value && value.replace(/[^\d]/g, '');
            if ((phoneValue && /^(\d)(?!\1+$)\d{9}$/.test(phoneValue)) || !phoneValue) {
              return true;
            }
          })
          .nullable() :
        yup
          .string()
          .transform((value) =>
            value === '' || value === null || value === undefined ? null : value,
          )
          .test('Phone', `Invalid  ${fieldLabel}`, (value) => {
            const phoneValue = value && value.replace(/[^\d]/g, '');
            if ((phoneValue && /^(\d)(?!\1+$)\d{9}$/.test(phoneValue)) || !phoneValue) {
              return true;
            }
          })
          .nullable();
    schema[fieldName] = validator;
  } else if (fieldType === 'email') {
    const validator = yup['string']().email('Email is invalid');
    schema[fieldName] = validator;
  } else {
    if (!yup[fieldType]) {
      return schema;
    }
    let validator = yup[fieldType]();

    if (fieldType === 'number') {
      validator = yup[fieldType]().transform((value) => (isNaN(value) ? undefined : value));
    } else if (fieldType === 'string') {
      validator = yup[fieldType]().transform((value) =>
        value === '' || value === null || value === undefined ? undefined : value,
      );
    } else if (fieldType === 'mixed') {
      validator = yup[fieldType]().transform((value) =>
        value === '' || value === null || value === undefined ? undefined : value,
      );
    } else if (fieldType === 'date') {
      validator = yup[fieldType]()
        .nullable()
        .min('01/01/1900', 'Invalid Date')
        .max('01/01/2100', 'Invalid Date')
        .transform((curr, orig) => (orig === '' ? null : curr))
        .typeError('Invalid Date');
    }

    // validations.forEach((validation) => {
    //     const { params, type } = validation;
    //     if (!validator[type]) {
    //         return;
    //     }
    //     validator = validator[type](...params);
    // });

    schema[fieldName] = validator;
  }
  return schema;
}
